<!-- Zweck: Stellt die HTML-Struktur für app no permission component im Frontend bereit. -->
<div class="errorcontent">
  <div>
    <div class="errorlogobox">
      <img class="logo" src="{{cfg.domainconfig.logofilename}}"/>
    </div>


    <div class="errorbox">
      <h1>Keine Berechtigung</h1>

      <hr>


      <h4>Leider haben Sie nicht die Berechtigung auf diese Ressource zuzugreifen.</h4>

      <hr>

      <button mat-flat-button routerLink="/" color="primary">
        Zum Dashboard
      </button>
    </div>
  </div>
</div>
